import { useCallback } from 'react';
import { useRouter } from '@okapi/router-react';
import { isTouchScreen, analytics } from 'utils';
import { SuggestionsGaMetaInfo } from 'components/header/components/searchbar/types';
import { SuggestionsProps } from 'components/header/components/searchbar/components/suggestions';

export interface UseButtonActionParams {
  onMouseEnter: SuggestionsProps['onMouseEnter'];
  onMouseLeave: SuggestionsProps['onMouseLeave'];
  onSelectSuggestion: SuggestionsProps['onSelectSuggestion'];
  searchQuery: SuggestionsProps['searchQuery'];
}

export const useSuggestionsButtonAction = (params: UseButtonActionParams) => {
  const { onMouseEnter, onMouseLeave, onSelectSuggestion, searchQuery } = params;
  const { navigate } = useRouter();

  return useCallback(
    (id: number, linkToNavigate?: string, gaMeta?: SuggestionsGaMetaInfo) => {
      const onSelectSuggestionCb = () => {
        const elementText = `${gaMeta?.block}/${gaMeta?.index}-${gaMeta?.text}`;
        analytics.sendEvent('GA:click', {
          name: 'searchHint', // constant for this type of action
          position: 'header', // constant for this type of action
          content: elementText,
          context: searchQuery,
        });

        onSelectSuggestion?.();
        if (linkToNavigate) {
          // `navigate` used instead of declarative `Link` component
          // because markup can be changed after `onSelectSuggestion` call
          // (e.g. popup closing),
          // so `Link` component will not dispatch event
          navigate(linkToNavigate);
        }
      };
      return isTouchScreen()
        ? { onTouchEnd: onSelectSuggestionCb }
        : { onMouseEnter: () => onMouseEnter(id), onClick: onSelectSuggestionCb, onMouseLeave };
    },
    [onMouseEnter, onMouseLeave, onSelectSuggestion, navigate, searchQuery]
  );
};
